import { Button, Popover } from 'antd';

type ItemType = string | number | { value?: string; key?: string | number };

type ItemsPreviewProps = {
    items: ItemType[];
    maxItems?: number;
};

export const ItemsPreview = ({ items, maxItems = 1 }: ItemsPreviewProps) => {
    if (!items || items.length === 0) return <span>-</span>;

    const getItemLabel = (item: ItemType) => {
        if (typeof item === 'string' || typeof item === 'number') {
            return String(item);
        }
        return item.value ?? '[object]';
    };

    const getItemKey = (item: ItemType, index: number) => {
        if (typeof item === 'string' || typeof item === 'number') {
            return item;
        }
        return item.key ?? index;
    };

    const labels = items.map(getItemLabel);

    const visibleLabels = labels.slice(0, maxItems);
    const hiddenLabels = labels.slice(maxItems);
    const hasHidden = hiddenLabels.length > 0;

    return (
        <div className="flex items-center gap-1">
            <span>{visibleLabels.join(', ')}</span>
            {hasHidden && (
                <Popover
                    trigger="click"
                    content={
                        <div className="flex flex-col">
                            {hiddenLabels.map((label, index) => (
                                <div
                                    key={getItemKey(
                                        items[maxItems + index],
                                        maxItems + index
                                    )}
                                >
                                    {label}
                                </div>
                            ))}
                        </div>
                    }
                >
                    <Button
                        variant="filled"
                        className="bg-primary-light text-blue-500 cursor-pointer flex items-center gap-1 hover:!bg-primary-light"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {`+${hiddenLabels.length}`}
                    </Button>
                </Popover>
            )}
        </div>
    );
};
